<main class="app-main">
  <!-- <ng-container *ngIf="isDev">
    <button [routerLink]="['', { outlets: { modal: ['menu'] } }]" mat-button class="menu">Menu</button>
  </ng-container> -->
  <div class="app-contents">
    <router-outlet></router-outlet>
    <div *ngIf="isDev">
      <app-footer-menu></app-footer-menu>
    </div>
  </div>
</main>